import { createSelector } from 'reselect';
import { STATE_NAME } from './constants';

export const getStateSlice = state => state.get(STATE_NAME);

export const getFeedbackMap = state => getStateSlice(state).get('feedback');

export const getFeedback = createSelector(
  getFeedbackMap,
  feedbackMap => feedbackMap.toList()
);

export const getFeedbackCount = state =>
  getStateSlice(state).get('feedbackCount');

export const getFeedbackHighlight = state =>
  getStateSlice(state).get('isHighlightFeedback');

export const getFeedbackDeleted = state =>
  getStateSlice(state).get('isDeletedFeedback');

export const getIsFetching = state => getStateSlice(state).get('isFetching');
export const getFetching = state =>
  getStateSlice(state).get('isFetchingFeedback');

export const getFetchError = state => getStateSlice(state).get('fetchError');

export const getIsAllFetched = state =>
  getStateSlice(state).get('isAllFetched');
